import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { MarkAsShippedContext } from '../../../context';
import { MARK_AS_SHIPPED_DEDUCT_INVENTORY } from '../../../constants';

import style from '../../style.module.less';

const options = [
  {
    id: 0,
    name: 'Deduct Inventory',
    value: true,
  },
  {
    id: 1,
    name: 'Do Not Deduct Inventory',
    value: false,
  },
];

const OrderNumberBulkUpdate = () => {
  const { bulkUpdateFulfillmentPlans } = useContext(MarkAsShippedContext);

  return (
    <DropdownMenu className={style['bulk-update-item']}>
      <DropdownMenuToggler>
        <FormattedMessage defaultMessage='Inventory' description='markAsShippedmodal.button.inventory' id='5Vm1Yy' />
      </DropdownMenuToggler>
      {options.map((option) => (
        <DropdownMenuItem
          key={option.id}
          onClick={() => bulkUpdateFulfillmentPlans(MARK_AS_SHIPPED_DEDUCT_INVENTORY, JSON.parse(option.value))}
        >
          {option.name}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

export default OrderNumberBulkUpdate;
